"use client";
import { IBlocks } from "@/types";
import React from "react";
import type { BlockUpdateFunction } from "./utils/blocks-map";
import AdminPopover from "./utils/AdminPopover";
interface Props {
    edit?: boolean;
    block: IBlocks;
    update?: BlockUpdateFunction;
}
export default function BlockTwitterFeed({ edit, block, update }: Props) {
    const [blockUpdate, setBlockUpdate] = React.useState(block);
    return (
        <AdminPopover
            edit={edit}
            className={block.show ? "" : "opacity-30"}
            title={"Twitter Feed"}
            block={block}
            update={update}
            setBlockUpdate={setBlockUpdate}
        >
            <div
                className={`relative flex w-full flex-row flex-wrap gap-2 p-2`}
                id="twitterTimeline"
            >
                <iframe
                    src={`https://syndication.twitter.com/srv/timeline-profile/screen-name/${blockUpdate.url}?theme=dark&hideScrollBar=true&hideBorder=true`}
                    width={"100%"}
                    height={"500px"}
                    className="rounded-lg"
                />
            </div>
        </AdminPopover>
    );
}
